import { useFeatureIsOn } from '@growthbook/growthbook-react'
import type { ReactNode } from 'react'
import NoMatch from '~/pages/NoMatch'

interface FeatureFlagRouteProps {
  flag: string
  children: ReactNode
}

const FeatureFlagRoute = ({ flag, children }: FeatureFlagRouteProps) => {
  const isOn = useFeatureIsOn(flag)
  return isOn ? <>{children}</> : <NoMatch />
}

export default FeatureFlagRoute
